import { FcCancel } from "react-icons/fc";
function Failure() {

    return (
        <div className="h-screen flex justify-center">
            <div className="flex flex-col items-center space-y-6 mt-7">
                <FcCancel className="text-9xl"/>
                <h2 className="text-2xl">Lo sentimos a ocurrido un error en el pago</h2>
            </div>
        </div>
    );
}

export default Failure;
